import { render, staticRenderFns } from "./InstagramDmTestCodePanel.vue?vue&type=template&id=12c69676&scoped=true"
import script from "./InstagramDmTestCodePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramDmTestCodePanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramDmTestCodePanel.vue?vue&type=style&index=0&id=12c69676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c69676",
  null
  
)

export default component.exports